import { DeleteIconSVG } from '../../../img/uploadDocument/uploadDocumentSVG';
import RadioInput from 'src/Admin/components/common/radio';
import GenericButton from '../../common/button/GenericButton/GenericButton';
import { maskedSSN } from 'src/common/masking';
import { useSelector } from 'react-redux';

const MemberSelectedItemComponent = ({
  onChangeHandler,
  item,
  makeDataClear,
  isSearchScreen = false,
}) => {
  console.log(item, item?.OID, 'MemberSelectedItemComponent ITEM');
  const { adminConfigData = {} } = useSelector((state) => state.user || {});
  const getMemberIdKey = () => {
    if (adminConfigData?.attributeNameConfiguration?.length > 0) {
      const configuredData =
        adminConfigData?.attributeNameConfiguration?.filter((item) => {
          return item?.memberID === true;
        });
      if (configuredData[0]?.memberID && configuredData[0]?.attributeKey) {
        const key = configuredData[0]?.attributeKey;
        const capitilizedKey = key[0].toUpperCase() + key.slice(1);
        return capitilizedKey;
      } else {
        return '';
      }
    } else {
      return '';
    }
  };
  const MEMBER_ID_CONFIGURED_KEY = getMemberIdKey();
  return (
    <div
      className={`${
        isSearchScreen
          ? 'blob-list-item-border-added p-2'
          : 'blob-list-item-border'
      }`}
    >
      <div className="d-flex broker-list-item justify-content-between align-items-center">
        <div className="d-flex">
          <div className="d-flex">
            {!isSearchScreen && (
              <div className="pt-2">
                <RadioInput
                  type="checkbox"
                  id={item?.OID}
                  name={item?.OID}
                  className="p-0 mb-3"
                  onChange={(e) =>
                    onChangeHandler(e, item[MEMBER_ID_CONFIGURED_KEY])
                  }
                  checked={item?.isChecked || false}
                />
              </div>
            )}
          </div>
          <div className="pl-3">
            <div>
              <span
                className={`${
                  isSearchScreen ? 'blob-item-name-1-added' : 'blob-item-name-1'
                }`}
              >
                {item?.FirstName + ' ' + item?.LastName}
              </span>
            </div>
            {item?.MemberType && (
              <div className="member-type">User type : {item?.MemberType}</div>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div>
            <div>
              {item && item[MEMBER_ID_CONFIGURED_KEY] && (
                <div className="blob-item-desc-3">
                  MemberID: {item[MEMBER_ID_CONFIGURED_KEY]}
                </div>
              )}
            </div>
            <div>
              {item?.SocialSecurityNumber && (
                <div className="blob-item-desc-3">
                  SSN: {maskedSSN(4, item?.SocialSecurityNumber)}
                </div>
              )}
            </div>
          </div>

          {isSearchScreen && (
            <div className="criteria-selection-block-action selection-block">
              <GenericButton
                className="pl-0 delete-cliteria-btn"
                variant="link"
                onClick={() => makeDataClear()}
              >
                <DeleteIconSVG className={'deleteIconSVG'} />
              </GenericButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberSelectedItemComponent;
